export const applicationListConstants = {
	RESET_APPLICATION_ENTRY_STATE: "RESET_APPLICATION_ENTRY_STATE",

	UPDATE_APPLICATION_STATUS: "APPLICATION_LIST_UPDATE_STATUS",
	SET_SELECTED_STATUS_FILTER: "SET_SELECTED_STATUS_FILTER",
};
